import ApiService from "@/common/api.service";

export default {
  upgradePlan(category) {
    return ApiService.post("ielts/member-package", { category });
  },
  pointPackages() {
    return ApiService.get("ielts/point-packages");
  }
};
